import { createContext } from 'react';

export const FieldContext = createContext();
export const OptionsContext = createContext();
export const MetadataEntryContext = createContext();
export const UserContext = createContext();
export const FormContext = createContext();
export const FieldsetsContext = createContext();
export const MailerContext = createContext();
export const FilterFieldsContext = createContext();
export const QueryContext = createContext();
export const SubmissionContext = createContext();
